import specialViewMap from "./specialViewMap.js";
import { getTimeView, getCurrentDateTime, genMsgId } from "./libs.js";
import { 
	resetChat, 
	getChatId, 
	showFreqQuests, 
	sendMessages, 
	prepareUserMessage, 
	updateMsgHistory, 
	restoreMsgStorage, 
	updateMsgContent, 
	makeAssistantMsg,
	createRenderBubble,
	scrollMsgsContainerDown,
	createNewChat,
	removeMsg
} from "./chat.js";
import { kitanBotOpen, kitanBotClose } from "./botBtn.js";
import { cartHoroshop } from "./extraSysPrompt.js";
import { getSpecialViewFromMsg } from "./toolsHandlers.js";

function doAction(action, params, callback) {
	url = BACKSERV;
	fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ action: action, params: params })
	})
	.then(response => response.json())
	.then(data => {
    callback(data);
  })
  .catch(error => {
    console.error("Err of request:", error);
  });
}

function chatbotInit() {
	console.log("chatbotInit");

	document.querySelector(".kitan-bot-btn").addEventListener("click", e => {
		const self = e.currentTarget;
		if(self.classList.contains("kb-state-closed")) {
			kitanBotOpen();
		} else {
			kitanBotClose();
		}
	});



	const chat = document.querySelector(".chat-container");
	const header = document.querySelector(".kb-header");

	setInterval(() => {
		if(chat.querySelectorAll(".message.user").length) {
			if(!header.classList.contains("kb-state-compact")) {
				header.classList.remove("kb-state-main");
				header.classList.add("kb-state-compact");
			}
		} else {
			if(!header.classList.contains("kb-state-main")) {
				header.classList.remove("kb-state-compact");
				header.classList.add("kb-state-main");
			}
		}
	}, 100);

	document.querySelector(".kb-chat-clear").addEventListener("click", e => {
		createNewChat();
	});

	document.querySelector(".chat-control-btns .like").addEventListener("click", e => {
		const channel_name = "kitan_bot_" + getChatId();

		doAction("logs.rating", {
			"channel_name": channel_name,
			"rating": 1
		}, resp => {});

		localStorage.setItem("user_rating", 1);
		e.currentTarget.classList.add("active");
		document.querySelector(".chat-control-btns .dislike").classList.remove("active");
	});

	document.querySelector(".chat-control-btns .dislike").addEventListener("click", e => {
		const channel_name = "kitan_bot_" + getChatId();

		doAction("logs.rating", {
			"channel_name": channel_name,
			"rating": -1
		}, resp => {});
		
		localStorage.setItem("user_rating", -1);
		e.currentTarget.classList.add("active");
		document.querySelector(".chat-control-btns .like").classList.remove("active");
	});


	if(localStorage.getItem("user_rating") === "1") {
		document.querySelector(".chat-control-btns .like").classList.add("active");
	} else if(localStorage.getItem("user_rating") === "-1") {
		document.querySelector(".chat-control-btns .dislike").classList.add("active");
	}



	let textarea = document.querySelector("#msg-area");
	textarea.addEventListener('input', e => {
		textarea.style.height = 'auto';
		if(!textarea.value) {
			textarea.style.height = "20px";
		} else {
			textarea.style.height = textarea.scrollHeight + 'px';
		}
	});

	textarea.addEventListener('focus', e => {
		e.currentTarget.parentNode.parentNode.classList.add("focused");
	});

	textarea.addEventListener('blur', e => {
		e.currentTarget.parentNode.parentNode.classList.remove("focused");
	});

	textarea.addEventListener('input', e => {
		if(e.currentTarget.value.length) {
			e.currentTarget.parentNode.parentNode.classList.add("ready-to-send");
		} else {
			e.currentTarget.parentNode.parentNode.classList.remove("ready-to-send");
		}
	});

	textarea.addEventListener("keydown", e => {
		if (e.key === "Enter" && !e.shiftKey) {
			e.preventDefault();
			document.querySelector(".msg-send").click();
		}
	});

	document.querySelector(".msg-send").addEventListener("click", e => {

		let msgtext = textarea.value;
		if(!msgtext.length) {
			return;
		}

		if(!document.querySelector(".msg-form").classList.contains("ready-to-send")) {
			return;
		}

		textarea.value = "";
		textarea.innerHTML = "";
		textarea.style.height = "20px";
		

		const chat = document.querySelector(".chat-container");
		chat.appendChild(createRenderBubble("user", true, msgtext).message);
		scrollMsgsContainerDown();


		const msgid = makeAssistantMsg();

		let cart = cartHoroshop();
		if(cart) {
			cart = JSON.stringify(cart);
			msgtext = `[Список товаров пользователя из корзины]${cart}[конец списка]\n${msgtext}`;
		}

		sendMessages(
			msgid,
			prepareUserMessage(msgtext), 
			function(resp, msgid){
				if(resp["status"] != "done") {
					return;
				}
				let specialViewContent = getSpecialViewFromMsg(resp["content"]);
				let content = resp["content"].split("front_special_view")[0].trim();
				if(content.length) {
					content = marked.parse(content).trim();
					updateMsgContent(msgid, content);
				} else {
					removeMsg(msgid);
				}

				if(specialViewContent) {
					if(
						content.length &&
						(specialViewContent.querySelector(".kb-product-card")
						|| specialViewContent.querySelector(".single-btn"))
					) {
						const amsgs = document.querySelectorAll(".chat-container .message.agent.assistant");
						amsgs[amsgs.length - 1].querySelector(".rightside").appendChild(specialViewContent);
					} else {
						document.querySelector(".chat-container").appendChild(specialViewContent);
					}
					updateMsgHistory();
				}
				
				scrollMsgsContainerDown();
			}
		);
	});
}

function loadAndRenderKbChatContainer(htmlTemplateUrl, callback) {
	console.log(htmlTemplateUrl);
	const xhr = new XMLHttpRequest();
	xhr.onreadystatechange = function() {
		if (this.readyState == 4 && this.status == 200) {
			const template = document.createElement("div");
		  template.innerHTML = xhr.responseText;
		  document.querySelector("body").append(template.querySelector(".kitan-bot-widget"));
		  callback();
		}
	};

	xhr.open("GET", htmlTemplateUrl, true);
	xhr.send();
}

function initKbChat(sitename, aiserv, backserv, htmlTemplateUrl) {
	window.AISERV = aiserv;
	window.BACKSERV = backserv;
	window.SITENAME = sitename;

	window.doAction = doAction;

	doAction("control.on_site", {
		"site": sitename
	}, resp => {
		if(!resp.is_enabled) {
			return;
		}

		loadAndRenderKbChatContainer(htmlTemplateUrl, () => {
			chatbotInit();
			window.showFreqQuests = showFreqQuests;
			window.resetChat = resetChat;	
			window.cartHoroshop = cartHoroshop;
		}); 
	});
	
	
}

window.initKbChat = initKbChat;